"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadRef = exports.Load = void 0;
var mobx_keystone_1 = require("mobx-keystone");
var pluralize_1 = __importDefault(require("pluralize"));
var load_1 = require("../constants/load");
var api = __importStar(require("../services/api"));
var firebase_1 = __importDefault(require("../services/firebase"));
var models_1 = require("../utils/models");
var LoadStop_1 = require("./LoadStop");
var LoadType_1 = require("./LoadType");
var LoadUnit_1 = require("./LoadUnit");
var Manifest_1 = require("./Manifest");
var User_1 = require("./User");
var Load = /** @class */ (function (_super) {
    __extends(Load, _super);
    function Load() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.etaTracker = null;
        _this.getRefId = function () { return "".concat(_this.id); };
        _this.getUnitName = function (unit, plural) {
            var loadUnit = _this[unit];
            if (!loadUnit || !loadUnit.isValid) {
                return null;
            }
            if (plural) {
                return (0, pluralize_1.default)(loadUnit.current.name);
            }
            return loadUnit.current.name;
        };
        _this.updateAPI = (0, mobx_keystone_1._async)(function (data) {
            var rootStore, entities, error_, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rootStore = (0, mobx_keystone_1.getRootStore)(this);
                        if (!rootStore || !rootStore.token)
                            return [2 /*return*/, { errors: { detail: null }, ok: false }];
                        entities = undefined;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.updateFullLoad(rootStore.token, this.id, data)];
                    case 2:
                        (entities = (_a.sent()).response.entities);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log('[DEBUG] error', error_1.message);
                        error_ = (0, models_1.getError)(error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (entities) {
                            rootStore.setLoad(entities, true);
                            rootStore.fetchLoadTableRows({ id__in: [this.id] }, []);
                        }
                        return [2 /*return*/, error_ || (0, models_1.getSuccess)()];
                }
            });
        });
        return _this;
    }
    Load_1 = Load;
    Object.defineProperty(Load.prototype, "displayID", {
        get: function () {
            if (this.dmId) {
                return this.dmId.toString();
            }
            return this.getRefId();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "displayStatus", {
        get: function () {
            return (0, load_1.getDisplayStatus)(this.status);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "manifestId", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.id : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "manifestNumber", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.manifestNumber : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "organization", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.organization : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "terminal", {
        // get billOfLadingNumber() {
        //   return this.manifest.isValid
        //     ? this.manifest.current.billOfLadingNumber
        //     : '';
        // }
        get: function () {
            return this.manifest.isValid ? this.manifest.current.revenueTerminal : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "shipper", {
        get: function () {
            return this.shipperStop.isValid ? this.shipperStop.current.contact : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "receiver", {
        get: function () {
            return this.consigneeStop.isValid
                ? this.consigneeStop.current.contact
                : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "billTo", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.billTo : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "billToOptions", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.billToOptions : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Load.prototype, "billToThirdParty", {
        get: function () {
            return this.manifest.isValid ? this.manifest.current.billToThirdParty : '';
        },
        enumerable: false,
        configurable: true
    });
    Load.prototype.addPositionKeyToFirebase = function (key) {
        firebase_1.default.db.ref("loads/".concat(this.id, "/positions/").concat(key)).set(true);
    };
    Load.prototype.update = function (data, forceUpdate) {
        var _this = this;
        var rootStore = (0, mobx_keystone_1.getRootStore)(this);
        if (!rootStore) {
            return;
        }
        var result = Load_1._formatData(rootStore, data, forceUpdate);
        if (result) {
            var load = result.load, orderStops = result.orderStops;
            Object.assign(this, load);
            if (orderStops && orderStops.length > 0) {
                this.orderStops.clear();
                orderStops.forEach(function (stop) {
                    var newStop = LoadStop_1.LoadStop.create(rootStore, stop);
                    if (newStop) {
                        _this.orderStops.add(newStop);
                    }
                });
            }
        }
    };
    var Load_1;
    Load._formatData = function (rootStore, data, forceUpdate) {
        var load = data;
        try {
            if (!rootStore.manifests.has("".concat(data.manifest)) || forceUpdate) {
                rootStore.fetchManifest(data.manifest);
            }
            load.manifest = (0, Manifest_1.manifestRef)("".concat(data.manifest));
            var orderStops = data.orderStops;
            if (data.orderStops) {
                var maxStop_1 = data.orderStops.length;
                data.orderStops.forEach(function (stop) {
                    var newStop = LoadStop_1.LoadStop.create(rootStore, stop);
                    if (newStop) {
                        rootStore.loadStops.set("".concat(newStop.id), newStop);
                        if (newStop.stopNumber === 1) {
                            load.shipperStop = (0, LoadStop_1.loadStopRef)("".concat(newStop.id));
                        }
                        if (newStop.stopNumber === maxStop_1) {
                            load.consigneeStop = (0, LoadStop_1.loadStopRef)("".concat(newStop.id));
                        }
                    }
                });
            }
            if (!rootStore.users.has("".concat(data.createdBy))) {
                rootStore.fetchUser(data.createdBy);
            }
            load.dispatcher = (0, User_1.userRef)("".concat(data.createdBy));
            if (data.loadType) {
                var loadType = new LoadType_1.LoadType(data.loadType);
                rootStore.loadTypes.set("".concat(loadType.id), loadType);
                load.loadType = (0, LoadType_1.loadTypeRef)(loadType);
            }
            else {
                load.loadType = null;
            }
            if (data.loadWeight) {
                var loadWeight = Math.round(data.loadWeight);
                load.loadWeight = loadWeight;
            }
            if (data.loadWeightUnit) {
                var loadWeightUnit = new LoadUnit_1.LoadUnit(data.loadWeightUnit);
                rootStore.loadUnits.set("".concat(loadWeightUnit.id), loadWeightUnit);
                load.loadWeightUnit = (0, LoadUnit_1.loadUnitRef)(loadWeightUnit);
            }
            else {
                load.loadWeightUnit = null;
            }
            if (data.loadLengthUnit) {
                var loadLengthUnit = new LoadUnit_1.LoadUnit(data.loadLengthUnit);
                rootStore.loadUnits.set("".concat(loadLengthUnit.id), loadLengthUnit);
                load.loadLengthUnit = (0, LoadUnit_1.loadUnitRef)(loadLengthUnit);
            }
            else {
                load.loadLengthUnit = null;
            }
            if (data.loadQuantityUnit) {
                var loadQuantityUnit = new LoadUnit_1.LoadUnit(data.loadQuantityUnit);
                rootStore.loadUnits.set("".concat(loadQuantityUnit.id), loadQuantityUnit);
                load.loadQuantityUnit = (0, LoadUnit_1.loadUnitRef)(loadQuantityUnit);
            }
            else {
                load.loadQuantityUnit = null;
            }
            if (data.estimatedTravelDistanceUnit) {
                var estimatedTravelDistanceUnit = new LoadUnit_1.LoadUnit(data.estimatedTravelDistanceUnit);
                rootStore.loadUnits.set("".concat(estimatedTravelDistanceUnit.id), estimatedTravelDistanceUnit);
                load.estimatedTravelDistanceUnit = (0, LoadUnit_1.loadUnitRef)(estimatedTravelDistanceUnit);
            }
            else {
                load.estimatedTravelDistanceUnit = null;
            }
            load.billOfLadingNumber = data.billOfLadingNumber
                ? data.billOfLadingNumber
                : '';
            delete load.orderStops;
            return {
                load: load,
                orderStops: orderStops,
            };
        }
        catch (error) {
            console.warn('[WARN] error', error);
            return null;
        }
    };
    Load.create = function (rootStore, data) {
        var result = Load_1._formatData(rootStore, data);
        if (result) {
            var load = result.load, orderStops = result.orderStops;
            var newLoad_1 = new Load_1(load);
            if (orderStops && orderStops.length > 0) {
                orderStops.forEach(function (stop) {
                    var newStop = LoadStop_1.LoadStop.create(rootStore, stop);
                    if (newStop) {
                        newLoad_1.orderStops.add(newStop);
                    }
                });
            }
            return newLoad_1;
        }
        else {
            return null;
        }
    };
    __decorate([
        mobx_keystone_1.modelAction
    ], Load.prototype, "addPositionKeyToFirebase", null);
    __decorate([
        mobx_keystone_1.modelAction
    ], Load.prototype, "update", null);
    __decorate([
        mobx_keystone_1.modelFlow
    ], Load.prototype, "updateAPI", void 0);
    Load = Load_1 = __decorate([
        (0, mobx_keystone_1.model)('doc-mate/Load')
    ], Load);
    return Load;
}((0, mobx_keystone_1.Model)({
    id: (0, mobx_keystone_1.prop)(),
    dmId: (0, mobx_keystone_1.prop)(),
    manifest: (0, mobx_keystone_1.prop)(),
    manifestLinkId: (0, mobx_keystone_1.prop)(),
    status: (0, mobx_keystone_1.prop)(),
    created: (0, mobx_keystone_1.prop)(),
    modified: (0, mobx_keystone_1.prop)(),
    shipperStop: (0, mobx_keystone_1.prop)(),
    consigneeStop: (0, mobx_keystone_1.prop)(),
    dispatcher: (0, mobx_keystone_1.prop)(),
    loadType: (0, mobx_keystone_1.prop)(),
    loadDescription: (0, mobx_keystone_1.prop)(),
    loadNotes: (0, mobx_keystone_1.prop)(),
    loadPhoto: (0, mobx_keystone_1.prop)(),
    loadWeight: (0, mobx_keystone_1.prop)(),
    loadWeightUnit: (0, mobx_keystone_1.prop)(),
    loadWidth: (0, mobx_keystone_1.prop)(),
    loadHeight: (0, mobx_keystone_1.prop)(),
    loadLength: (0, mobx_keystone_1.prop)(),
    loadLengthUnit: (0, mobx_keystone_1.prop)(),
    loadQuantity: (0, mobx_keystone_1.prop)(),
    loadQuantityUnit: (0, mobx_keystone_1.prop)(),
    estimatedTravelDistance: (0, mobx_keystone_1.prop)(),
    estimatedTravelDistanceUnit: (0, mobx_keystone_1.prop)(),
    orderNumber: (0, mobx_keystone_1.prop)(),
    sealNumber: (0, mobx_keystone_1.prop)(),
    trailerNumber: (0, mobx_keystone_1.prop)(),
    tripNumber: (0, mobx_keystone_1.prop)(),
    expedite: (0, mobx_keystone_1.prop)(),
    mode: (0, mobx_keystone_1.prop)(),
    broker: (0, mobx_keystone_1.prop)(),
    loadedOnSameTrailer: (0, mobx_keystone_1.prop)(),
    billOfLadingNumber: (0, mobx_keystone_1.prop)(),
    specialEquipment: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
    pickupNumber: (0, mobx_keystone_1.prop)(),
    poNumberShipper: (0, mobx_keystone_1.prop)(),
    poNumberConsignee: (0, mobx_keystone_1.prop)(),
    customerOrderNumber: (0, mobx_keystone_1.prop)(),
    partnerRefNumber: (0, mobx_keystone_1.prop)(),
    as400ManifestNumber: (0, mobx_keystone_1.prop)(),
    other: (0, mobx_keystone_1.prop)(),
    etas: (0, mobx_keystone_1.prop)(),
    orderStops: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
    accessorials: (0, mobx_keystone_1.prop)(function () { return (0, mobx_keystone_1.arraySet)(); }),
})));
exports.Load = Load;
exports.loadRef = (0, mobx_keystone_1.rootRef)('doc-mate/LoadRef', {
    getId: function (target) {
        if (target instanceof Load) {
            return "".concat(target.id);
        }
    },
});
